import Faq from "../../components/home/Faq";
import { useTranslation } from "react-i18next";
import Steps from "../../components/home/Steps";
import Member from "../../components/home/Member";
import { useState } from "react";
import Register from "./Register";
import Reasons from "../../components/home/Reasons";
import Footer from "../../layout/Footer";
import Competitors from "./Competitors";
import Main from "./Main";
import Globe from "@components/magicui/Globe";
import { Col, Row } from "react-bootstrap";
import ParticlesBackground from "@components/magicui/ParticlesBackground";
import CTA from "../../assets/wave.svg"
import Reasons1 from "@components/home/Reasons1";
const Home = ({ handleLogin }) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);
  const [activeForm, setActiveForm] = useState("in"); // "in" or "up"

  const openModal = (formType = "in") => {
    setActiveForm(formType);
    setShow(true);
  };

  return (
    <section className="w-100" >
       
      <Main openModal={openModal} />
      <Register
          show={show}
          setShow={setShow}
          handleLogin={handleLogin}
          activeForm={activeForm}
          setActiveForm={setActiveForm}
        />
<div className="position-relative d-flex justify-content-end">
  <img src={CTA} className="img-fluid w-75" alt="Description" />
  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
    <Reasons1 />
  </div>
</div>
      <div className="bg-white" style={{ position:'relative', zIndex:2}}>
    
        <div className="container-xl">
          
          <Reasons t={t} />
        <Steps t={t} />
        <Competitors t={t} />
        <Faq />
        <Member t={t} openModal={openModal} />
        </div>
        
      </div>
      <Footer t={t} />
    </section>
  );
};

export default Home;
